<template>
  <div>
    <table-widget :items="statuses" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage"
      :filter.sync="filter">
      <template slot="buttons">
      </template>
      <template slot="content">
        <b-table striped :items="statuses" :fields="fields" :per-page="perPage" :current-page="currentPage"
          :filter="filter" @filtered="onFiltered" small show-empty :tbody-transition-props="transProps"
          empty-filtered-text="There are no statuses that match your search criteria.">
          <template v-slot:cell(status)="data">
            {{ data.item[statusFieldName] }}
          </template>
          <template v-slot:cell(user)="data">
            {{ data.item.createdBy }}
          </template>
          <template v-slot:cell(statusDate)="data">
            {{ data.item.createdDate | formatDateTime }}
          </template>
          <template v-slot:cell(statusNotes)="data">
            {{ data.item.notes }}
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import TableWidget from "../table-widget"
import * as _ from "lodash" // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      transProps: {
        // Transition name
        name: "fade"
      },
      items: [],
      fields: [
        { key: "status", label: "Status" },
        { key: "user", label: "User" },
        { key: "statusDate", label: "Date" },
        { key: "statusNotes", label: "Notes" }
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      selectedStatuses: []
    }
  },

  props: {
    statuses: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    statusFieldName: {
      type: String,
      required: false,
      default: "statusName"
    }
  },

  components: { "table-widget": TableWidget },

  computed: {},

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  },

  watch: {
    statuses: function () {
      if (this.statuses.length) {
        this.selectedStatuses = this.statuses
        this.totalRows = this.statuses.length
      }
    }
  },

  created() {
    if (this.statuses.length) {
      this.selectedStatuses = this.statuses
      this.totalRows = this.statuses.length
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
